module.exports = __webpack_public_path__ + "img/registerlogin_7.c0d0a2e7.jpg";